import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import ButtonLink from './ButtonLink';
import CookieConsentBanner from './CookieConsentBanner';

import { FormattedMessage } from 'react-intl';

// import ReactGA from 'react-ga';

import { useLocation } from 'react-router';
import { getCookieConsentValue } from 'react-cookie-consent';

import './CookieConsentBanner.css';
import 'react-accessible-accordion/dist/fancy-example.css';


const COOKIE_NAME = 'cookie-consent';
// const GA_ID = 'XXXXXXXXXXXX';

const removeCookies = () => {
  // Clear cookies
  document.cookie.split(';').forEach(function (c) {
    if (
      ![COOKIE_NAME, 'auth_token'].includes(c.replace(/^\ +/, '').split('=')[0])
    ) {
      document.cookie = c
        .replace(/^\ +/, '')
        .replace(
          /\=.*/,
          '=;expires=' +
            new Date().toUTCString() +
            ';path=/;domain=' +
            window.location.host.split(':')[0],
        );
    }
  });
  // Clear localStorage
  localStorage.clear();
};

const CookieConsentLink = ({ consentRef }) => {
  const [cookieValue, setCookieValue] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  // const [statistics, setStatistics] = useState(false);
  // const [gaEnabled, setGaEnabled] = useState(false);

  const location = useLocation();
  const bannerRef = useRef();
  const linkRef = useRef();

  useEffect(() => {
    if (showBanner && bannerRef.current) {
      bannerRef.current.focus();
    }
  }, [showBanner]);

  useEffect(() => {
    if (cookieValue === null) {
      setCookieValue(getCookieConsentValue(COOKIE_NAME) || '');
    } else {
      // setStatistics(cookieValue.match(/statistics/));
    }
    if (cookieValue === '') {
      setShowBanner(true);
    }
  }, [cookieValue]);

  // useEffect(() => {
  //   if (statistics) {
  //     ReactGA.initialize(GA_ID);
  //     setGaEnabled(true);
  //   } else if (gaEnabled) {
  //     if (!!window.dataLayer) {
  //       delete window.dataLayer;
  //     }
  //     window[`ga-disable-${GA_ID}`] = true;
  //     removeCookies();
  //     setGaEnabled(false);
  //   }
  // }, [statistics]);

  // useEffect(() => {
  //   if (gaEnabled) {
  //     ReactGA.pageview(window.location.pathname + window.location.search);
  //   }
  // }, [location, gaEnabled]);

  return (
    <div
      ref={linkRef}
      key="2"
      style={{
        display: 'inline',
        fontSize: '1rem',
        textAlign: 'center',
        paddingBottom: '20px',
      }}
    >
      <ButtonLink
        onClick={() => {
          setShowBanner(true);
          setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
          }, 100);
        }}
      >
        <FormattedMessage id="volto-cookie-consent-link" defaultMessage="Cookie settings" />
      </ButtonLink>
      {showBanner && consentRef?.current
        ? ReactDOM.createPortal(
            <div
              ref={bannerRef}
              key="1"
              role="alert"
              aria-label="Evästeasetukset"
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex="0"
            >
              <CookieConsentBanner
                force={true}
                onClose={() => {
                  setShowBanner(false);
                  setCookieValue(getCookieConsentValue(COOKIE_NAME) || '');
                }}
              />
            </div>,
            consentRef.current,
          )
        : null}
    </div>
  );
};

export default CookieConsentLink;
